import React, { useEffect, useState } from "react";
import styles from "./PendingBookings.module.css";
import swal from "sweetalert";
import { useHistory, useLocation } from "react-router";
import axios from "../../axios.js";

const PendingBookings = () => {
  // const [pendingShoot, setPendingShoot] = useState();
  const location = useLocation();
  // User
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("auth")));

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("auth")));
  }, [location]);
  // const [refresh, setRefresh] = useState(false)
  // const [bookBtnClickedHandler, setBookBtnClickedHandler] = useState(false)
  const history = useHistory();

  //? Old >>>>>>>>>>>>>>>>
  // const apiKey = process.env.REACT_APP_URL;
  // let url = apiKey + "booking/get-booking-pending-record/";
  // const fetchPendingBookings = () => {
  //   let api = url + localStorage.getItem("userEmail");

  //   fetch(api)
  //     .then((response) => {
  //       return response.json();
  //     })
  //     .then((data) => {
  //       setPendingShoot(data.data.reverse());
  //     })
  //     .catch((error) => {
  //     });
  // };

  // package Deletion.....
  const askForDelete = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this package!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deletePackage(id);
      }
    });
  };

  //Sidd0203
  const [pendingShoot, setPendingShoot] = useState([]);
  const [deleted, setDeleted] = useState(false);
  const [orderId, setOrderId] = useState();

  const getOrderList = async () => {
    try {
      const res = await axios.get("/book/request/specificCustomers");
      setOrderId(res.data[0]._id);
      setPendingShoot(res.data[0].requests);
      console.log(res.data[0].requests);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getOrderList();
  }, [location]);

  const deletePackage = async (requestId) => {
    try {
      const res = await axios.put(
        `/book/request/delete/${orderId}/${requestId}`
      );
      setDeleted(!deleted);
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getOrderList();
  }, [deleted]);

  // Payment
  const handlePayment = async (price, requestId) => {
    const name = user.result.firstname + user.result.lastname;
    const orderIdd = `${orderId}-${requestId}-${Date.now()}`;
    const newprice = price.replace(/,/g, "");
    console.log(orderIdd);
    const orderData = {
      amount: newprice,
      orderId: orderIdd,
      customerName: name,
      customerEmail: user.result.email,
      customerPhone: user.result.mobile,
    };

    try {
      const res = await axios.post(`/payment`, orderData);
      console.log(res.data);
      window.location.href = res.data.paymentLink;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles["NewDashboard-photoshootCard"]}>
      {pendingShoot && pendingShoot.length > 0 ? (
        pendingShoot.map((request, id) => {
          return (
            request.status !== "confirmed" && (
              <div className={styles["pending-booking__container"]} key={id}>
                <h6>{request.orderData.date}</h6>
                <div className={styles["pending-booking__inner"]}>
                  <h3>{request.orderData.city}</h3>
                  <p>{request.orderData.service}</p>
                  <p>
                    {request.orderData.package} (₹
                    {request.orderData.package_price})
                  </p>
                </div>
                <h6>
                  Status : <span>{request.status}</span>
                </h6>
                <div className={styles["pendingBookings-action__container"]}>
                  {request.status === "accepted" && (
                    <button
                      className={styles["pendingBookings-action__btn"]}
                      onClick={() =>
                        handlePayment(request.orderData.package_price, request._id)
                      }
                    >
                      Pay
                    </button>
                  )}
                  <button
                    onClick={() => {
                      askForDelete(request._id);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            )
          );
        })
      ) : (
        <h3 className={styles["no_confirm_booking_heading"]}>
          No Pending bookings to show!
        </h3>
      )}
    </div>
  );
};

export default PendingBookings;
